import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppBootstrapModule } from './bootstrap.module'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {AppMaterialModule} from './material.module';
import{SharedModule} from './sharedModule';
import {
  MatTabsModule, MatCardModule, MatDialogModule,
  MatDatepickerModule,
  MatRadioModule, MatSelectModule,
} from '@angular/material';
 import {HttpErrorInterceptor,tokenInterceptor}from './globalservices/intercepter'
import {AuthGuard}from './app.guard';
import { HttpClientModule ,HTTP_INTERCEPTORS} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {SpeakerdashboardComponent} from '../app/components/speaker/speakerdashboard/speakerdashboard/speakerdashboard.component';
import {EventSesrvice} from './event.service';
import {MatInputModule} from '@angular/material';
import { LoginComponent } from './components/authentication/login/login.component';
import{LoginService} from './globalservices/login.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SpeakerdashboardComponent
  ],
  imports: [
    BrowserModule,
    MatInputModule,
    BrowserAnimationsModule,
    SharedModule,
    AppBootstrapModule,
    MatDialogModule,
    HttpClientModule,
    AppMaterialModule,
    AppRoutingModule
  ],
  providers: [LoginService,
    AuthGuard,
    EventSesrvice,
    { 
      provide:HTTP_INTERCEPTORS, 
      useClass: HttpErrorInterceptor, 
      multi: true
    
    },
    { 
      provide:HTTP_INTERCEPTORS, 
      useClass: tokenInterceptor, 
      multi: true
    
    },
  ],
  entryComponents:[LoginComponent],
  bootstrap: [AppComponent],
  
})
export class AppModule { }
